import { type MetaFunction } from "@remix-run/node";

import { emersonRoutes } from "@emerson/data/emersonRoutes";

import type { loader } from "./loader";

const meta: MetaFunction<typeof loader> = ({ data }) => {
  if (!data) return [];

  const { brands, taxonomies, url } = data;

  const canonicalLinks = [
    ...brands.map(
      brand => `${emersonRoutes.base}/brand/${brand.name.split(" ").join("-")}-${brand.id}`
    ),
    ...taxonomies.map(
      taxonomy =>
        `${emersonRoutes.base}/category/${taxonomy.name.split(" ").join("-")}-${taxonomy.id}`
    ),
  ];

  return canonicalLinks.map(canonicalLink => ({
    tagName: "link",
    rel: "canonical",
    href: `${url}${canonicalLink}`,
  }));
};

export { meta };
